import React from "react";
import { FormControl } from "@mui/material";
import NoTicketDetail from "../../../FlightPackage/NoTicketDetail";
import { UpDownTimeOnEachLeg } from "../../../sharedCode/TimeCalculator";
import { AircraftExtended, CompanyExtended, JobExtended, PersonExtended, TicketExtended } from "../../../Utils/TypeExtensions";
import { ValidationResult } from "../../../Utils/Interfaces";
import { TicketLineItemType } from "../../../sharedCode/avroGraphql";
import Header from "../../../Components/ticket/header";
import DetailRows from "../../../Components/ticketFlightLegs/detailRows";
import UpDownFooter from "../../../Components/ticketFlightLegs/upDownFooter";
import DurationFooter from "../../../Components/ticketFlightLegs/durationFooter";
import DetailPage from "../../../Components/navigation/detailPage";

export const gridSpacing = 1;
export const rowMargin = 2;

export interface TicketProps {
    ticket: TicketExtended;
    errors: ValidationResult[];
    aircraftList: AircraftExtended[];
    ameList: PersonExtended[];
    companyList: CompanyExtended[];
    lineItemTypeList: TicketLineItemType[];
    minimumsRequiredList: number[];
    jobList: JobExtended[];
    pilotList: PersonExtended[];
    ticketList: TicketExtended[];
    isReadOnly: boolean;
    showForceReloadDialogue: () => void;
}

export function TicketFlightLegs(props: TicketProps): JSX.Element {
    if (!props.ticket) return <NoTicketDetail />;

    const upDownRequired = UpDownTimeOnEachLeg(props.ticket);

    return (
        <DetailPage>
            <FormControl fullWidth>
                <Header {...props} />
                <DetailRows key={`d${props.ticket.id}-${props.ticket.Locations?.length}`} {...props} />
                {upDownRequired && <UpDownFooter {...props} />}
                {!upDownRequired && <DurationFooter {...props} />}
            </FormControl>
        </DetailPage>
    );
}
